import { Typography } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';
import { Platform, PlatformImporter } from '../../services/integration.types';
import IntegrationBlockchainFormComponent from './integration-forms/Blockchain';
import IntegrationExchangeFormComponent from './integration-forms/Exchange';
import IntegrationExchangeCsvFormComponent from './integration-forms/ExchangeCsv';

interface IntegrationCreateComponentProps {
    platform: Platform;
    selectedImportType: string | null;
    onJobCreated: () => void;
}

const IntegrationCreateComponent: React.FC<IntegrationCreateComponentProps> = ({
    platform: platform,
    selectedImportType,
    onJobCreated,
}) => {
    const { t } = useTranslation();
    const excelUploadImporter: PlatformImporter = {
        id: 0,
        customText: '',
        displayName: 'Excel Upload',
        position: 0,
        type: 'excel',
        uri: '/import/import_xls',
        uploadFile: '',
        importFolder: '',
        customFields: [],
    };

    if (!platform)
        return (
            <Typography variant="h6" gutterBottom>
                {t('common.integration.selectPlatform')}
            </Typography>
        );

    switch (platform.platform_type) {
        case 'exchange':
        case 'wallet':
            return (
                <IntegrationExchangeFormComponent
                    selectedImportType={selectedImportType}
                    platform={platform}
                    onJobCreated={() => onJobCreated()}
                />
            );

        case 'blockchain':
            return (
                <IntegrationBlockchainFormComponent
                    platform={platform}
                    onJobCreated={() => onJobCreated()}
                />
            );

        case 'excelUpload':
            return (
                <IntegrationExchangeCsvFormComponent
                    platform={platform}
                    onJobCreated={() => onJobCreated()}
                    importer={excelUploadImporter}
                />
            );

        default:
            return (
                <Typography variant="h6" gutterBottom>
                    {t('integrations.create.platformNotSupported')}
                </Typography>
            );
    }
};

export default IntegrationCreateComponent;
